<template>
  <v-dialog v-model="dialogAltriDocumenti" max-width="80vw" persistent>
    <v-card>
      <v-card-title class="text-h5">Dettaglio altri documenti</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select :items="tipiDocumentiCollegati" outlined dense hide-details label="Tipo documento" v-model="tipoDocumento" item-value="codice" item-text="descrizione" return-object @change="changeTipoDocumento"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field v-model="riferimentoNumeroLinea" label="Riferito alla linea" outlined dense :rules="[rules.numero]" maxlength="4" hint="Numero della linea o delle linee di dettaglio della fattura alle quali si riferisce il documento così come identificato dai tre elementi successivi (IdDocumento, Data, NumItem); nel caso in cui il documento si riferisca all’intera fattura, questo elemento non deve essere valorizzato"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3"><v-text-field v-model="idDocumento" label="Numero documento" outlined dense hint="Numero del documento associato alla fattura o alla linea/linee di fattura indicate nell’elemento precedente"></v-text-field></v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-menu v-model="menuData" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataFormatted"
                  label="Data documento"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  
                  hint="Data del documento associato alla fattura o alla linea/linee di fattura indicate nell’elemento precedente"
                  @click:clear="dataDocumento = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataDocumento" no-title scrollable @input="menuData = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3"><v-text-field v-model="numItem" label="ID Singola voce" outlined dense hint="Identificativo della singola voce (linea del documento) all'interno del documento associata alla fattura o alla linea/linee di fattura indicate nell’elemento precedente"></v-text-field></v-col>
          <v-col cols="12" sm="6" md="4" lg="3"><v-text-field v-model="codiceCommessaConvenzione" label="Codice commessa/convenzione" outlined dense hint="Codice della commessa o della convenzione collegata alla fattura"></v-text-field></v-col>
          <v-col cols="12" sm="6" md="4" lg="3"><v-text-field v-model="codiceCup" label="Codice CUP" outlined dense hint="Codice gestito dal CIPE che caratterizza ogni progetto di investimento pubblico (Codice Unitario Progetto)"></v-text-field></v-col>
          <v-col cols="12" sm="6" md="4" lg="3"><v-text-field v-model="codiceCig" label="Codice CIG" outlined dense hint="Codice Identificativo della Gara"></v-text-field></v-col>
          <!-- <v-col><v-btn color="success" @click="onAggiungiDocumento">Aggiungi documento</v-btn></v-col> -->
        </v-row>
        <v-row justify="end">
          <v-btn class="mr-5 mb-2" :color="id ? 'info': 'success'" @click="onAggiungiDocumento">{{ id ? 'Salva modifiche' : 'Aggiungi documento' }}</v-btn>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-dialog v-model="dialogDelete" max-width="550px">
          <v-card>
            <v-card-title class="text-h5">Confermi la cancellazione del documento ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
          v-model="selected"
          item-key="id"
          :headers="headers"
          :items="documentiCollegati"
          :options.sync="options"
          class="elevation-1"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Documenti correlati</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:[`item.data`]="{ item }">
            {{ item.data | date }}
          </template>
          <template v-slot:no-data>
            <h3>Ancora nessun documento aggiunto</h3>  
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)" title="Modifica il documento">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)" title="Cancella il documento">mdi-delete</v-icon>
          </template>          
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="confirm">Chiudi</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import configurazioni from '@/services/configurazioniService.js'
import { randomHex } from '@/components/helpers'
import { validazioni } from '@/mixins/validazioni.js'

export default {
  props: {
    show: Boolean,
    item: Object
  },
  mixins: [
    validazioni
  ],
  data(vm) {
    return {
      dialogDelete: false,
      selected: [],
      totaleDocumenti: 0,
      menuData: false,
      dialogAltriDocumenti: false,
      id: '',
      tipoDocumento: null,
      tipiDocumentiCollegati: [],
      riferimentoNumeroLinea: '',
      idDocumento: '',
      dataDocumento: null,
      dataFormatted: vm.formatDate(moment().utcOffset(0, true).format('YYYY-MM-DD')),
      numItem: '',
      codiceCommessaConvenzione: '',
      codiceCup: '',
      codiceCig: '',
      options: { itemsPerPage: 50 },
      headers: [
        { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start' },
        { text: 'Riferimento Linee', value: 'riferimentoNumeroLinea' },
        { text: 'ID Documento', value: 'idDocumento' },
        { text: 'Data', value: 'data' },
        { text: 'Numero Linee', value: 'numItem' },
        { text: 'Commessa/Convenzione', value: 'codiceCommessaConvenzione' },
        { text: 'Codice CUP', value: 'codiceCup' },
        { text: 'Codice CIG', value: 'codiceCig' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      documentiCollegati: []
    }
  },
  watch: {
    show(value) {
      this.dialogAltriDocumenti = value
    },
    dataDocumento(val) {
      this.dataFormatted = this.formatDate(this.dataDocumento)
    },
    item() {
      this.documentiCollegati = this.item.documentiCollegati || []
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },
  async mounted() {
    const impostazioni = await configurazioni.getConfigurazione('documenti_impostazioni')
    this.tipiDocumentiCollegati = impostazioni.tipiDocumentiCollegati || []

    this.documentiCollegati = this.item.documentiCollegati || []
  },
  computed: {
    computedDataFormatted () {
      return this.formatDate(this.dataDocumento)
    }    
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    confirm() {
      this.dialogAltriDocumenti = false
      this.$emit('dialog-close')
    },
/*     cancel() {
      this.dialogAltriDocumenti = false
      this.$emit('dialog-cancel')
    }, */
    changeTipoDocumento(value) {

    },
    onAggiungiDocumento() {
      if (!this.tipoDocumento || !this.idDocumento) {
        return
      }
      let documento = {
        tipoDocumento: this.tipoDocumento,
        riferimentoNumeroLinea: this.riferimentoNumeroLinea,
        idDocumento: this.idDocumento,
        data: this.dataDocumento,
        numItem: this.numItem,
        codiceCommessaConvenzione: this.codiceCommessaConvenzione,
        codiceCup: this.codiceCup,
        codiceCig: this.codiceCig
      }
      if (this.id) {
        const index = this.documentiCollegati.findIndex(x => x.id === this.id)
        documento.id = this.id
        // this.documentiCollegati[index] = documento
        Object.assign(this.documentiCollegati[index], documento)
      } else {
        documento.id = randomHex(4)
        this.documentiCollegati.push(documento)
      }
      
      this.$emit('aggiornaDocumento', this.documentiCollegati)
      this.pulisciCampi()
    },
    pulisciCampi() {
      this.id = ''
      this.tipoDocumento = null
      this.riferimentoNumeroLinea = ''
      this.idDocumento = ''
      this.dataDocumento = null
      this.numItem = ''
      this.codiceCommessaConvenzione = ''
      this.codiceCup = ''
      this.codiceCig = '' 
    },
    editItem(item) {
      this.id = item.id
      this.tipoDocumento = item.tipoDocumento
      this.riferimentoNumeroLinea = item.riferimentoNumeroLinea
      this.idDocumento = item.idDocumento
      this.dataDocumento = item.data
      this.dataFormatted = this.formatDate(item.data)
      this.numItem = item.numItem
      this.codiceCommessaConvenzione = item.codiceCommessaConvenzione
      this.codiceCup = item.codiceCup
      this.codiceCig = item.codiceCig
    },
    deleteItem (item) {
      this.editedIndex = this.documentiCollegati.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    async deleteItemConfirm () {
      this.documentiCollegati.splice(this.editedIndex, 1)
      this.$emit('aggiornaDocumento', this.documentiCollegati)
      this.closeDelete()
    },
    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }    
  }
}
</script>
